export const inventoryRoutes = [
    {
        path: '/inventory',
        meta: { requiresHousehold: true },
        children: [
          {
            path: '',
            component: () => import(/* webpackChunkName: "inventory" */ '@/features/inventory/views/InventoryIndex.vue'),
          },
          {
            path: ':id',
            component: () => import(/* webpackChunkName: "shopping" */ '@/features/inventory/views/InventoryDetail.vue'),
          },
          {
            path: ':id/locations',
            component: () => import(/* webpackChunkName: "shopping" */ '@/features/inventory/views/InventoryLocations.vue'),
          }
        ]
    }
]
